import {
    ScreeningGeneralSubRouteType,
    ScreeningSubRouteType,
    TranslationsSubRouteType,
    UserSubRouteType,
    RouteType,
} from 'app/routing/route-type';
import { NgModule, Type } from '@angular/core';
import { DefaultExport, Route, RouterModule, Routes } from '@angular/router';
import { SessionService } from 'app/services/session.service';

const route = (
    type: RouteType | string,
    loadComponent: () => Promise<DefaultExport<Type<unknown>>>,
    title: string,
    pathMatch = 'full',
    children?: Routes,
) => {
    return {
        path: type,
        loadComponent,
        pathMatch,
        canActivate: [SessionService],
        data: { animation: type },
        children,
        title: `Gem | ${title}`,
    } as Route;
};

const routes: Routes = [
    { path: '', redirectTo: RouteType.login, pathMatch: 'full' },
    route(RouteType.login, () => import('app/components/login/login.component'), 'Login'),
    route(`:country/${RouteType.users}`, () => import('app/components/sitly-users/sitly-users.component'), 'Search'),
    route(`:country/${RouteType.users}/:userId`, () => import('app/components/user-profile/user-profile.component'), 'Profile', 'prefix', [
        { path: '', redirectTo: UserSubRouteType.profile, pathMatch: 'full' },
        route('**', () => import('app/components/user-profile/user-profile.component'), 'Profile'),
    ]),
    route(`:country/${RouteType.screening}`, () => import('app/components/screening/screening.component'), 'Grey list', 'prefix', [
        { path: '', redirectTo: ScreeningSubRouteType.general, pathMatch: 'full' },
        route(ScreeningSubRouteType.general, () => import('app/components/screening/general/general.component'), 'Grey list', 'prefix', [
            { path: '', redirectTo: ScreeningGeneralSubRouteType.greyList, pathMatch: 'full' },
            route(ScreeningGeneralSubRouteType.greyList, () => import('app/components/screening/general/general.component'), 'Grey list'),
            route(ScreeningGeneralSubRouteType.blackList, () => import('app/components/screening/general/general.component'), 'Black list'),
            route(ScreeningGeneralSubRouteType.suspects, () => import('app/components/screening/general/general.component'), 'Suspects'),
            route(
                ScreeningGeneralSubRouteType.quarantined,
                () => import('app/components/screening/general/general.component'),
                'Quarantined',
            ),
        ]),
        route(
            ScreeningSubRouteType.personalData,
            () => import('app/components/screening/personal-data/personal-data.component'),
            'Personal data',
        ),
        route(
            ScreeningSubRouteType.sensitivePhrases,
            () => import('app/components/screening/sensitive-phrases/sensitive-phrases.component'),
            'Phrases',
        ),
        route(ScreeningSubRouteType.exclusions, () => import('app/components/screening/exclusions/exclusions.component'), 'Exclusions'),
    ]),
    route(`:country/${RouteType.subscriptions}`, () => import('app/components/subscriptions/subscriptions.component'), 'Subscriptions'),
    route(`:country/${RouteType.feedbacks}`, () => import('app/components/feedbacks/feedbacks.component'), 'User feedback'),
    route(RouteType.settings, () => import('app/components/settings/settings.component'), 'Settings'),
    route(RouteType.translations, () => import('app/components/translations/translations.component'), 'Translations', 'prefix', [
        { path: '', redirectTo: TranslationsSubRouteType.translate, pathMatch: 'full' },
        route(
            TranslationsSubRouteType.translate,
            () => import('app/components/translations/translate/translate.component'),
            'Translations',
        ),
        route(TranslationsSubRouteType.add, () => import('app/components/translations/add/add.component'), 'Add translations'),
        route(
            TranslationsSubRouteType.publish,
            () => import('app/components/translations/publish/publish.component'),
            'Publish translations',
        ),
        route(TranslationsSubRouteType.groups, () => import('app/components/translations/groups/groups.component'), 'Translations group'),
    ]),
    route(RouteType.addGemUser, () => import('app/components/settings/add-gem-user/add-gem-user.component'), 'Add a GEM user'),
    route('**', () => import('app/components/not-found/not-found.component'), 'Page not found!'),
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
